import React from 'react';
import { useLanguage } from '@/services/languageService';
import MainLayout from '@/layouts/MainLayout';
import { Mail, AlertTriangle, HelpCircle } from 'lucide-react';

const ContactUs = () => {
  const { t } = useLanguage();

  return (
    <MainLayout>
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <h1 className="text-3xl font-bold mb-6 text-center text-purple-700">{t('contactUsTitle')}</h1>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h2 className="text-2xl font-semibold mb-4 text-purple-600">{t('contactUsGetInTouch')}</h2>
            <p className="mb-6">{t('contactUsGetInTouchContent')}</p>
            
            <div className="space-y-4">
              <div className="flex items-start">
                <Mail className="w-5 h-5 mr-3 text-purple-600 mt-1" />
                <div>
                  <h3 className="font-medium">{t('contactUsEmail')}</h3>
                  <p className="text-gray-600">
                    {t('contactUsEmail')}: contact@randompokemon.games
                  </p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h2 className="text-2xl font-semibold mb-4 text-purple-600">{t('contactUsHelpSupport')}</h2>
            <p className="mb-6">{t('contactUsHelpSupportContent')}</p>
            
            <div className="flex items-start mb-6">
              <HelpCircle className="w-5 h-5 mr-3 text-purple-600 mt-1" />
              <div>
                <h3 className="font-medium">{t('contactUsFAQ')}</h3>
                <p className="text-gray-600">{t('contactUsFAQContent')}</p>
              </div>
            </div>
            
            <div className="flex items-start">
              <AlertTriangle className="w-5 h-5 mr-3 text-purple-600 mt-1" />
              <div>
                <h3 className="font-medium">{t('contactUsBugReport')}</h3>
                <p className="text-gray-600">{t('contactUsBugReportContent')}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default ContactUs;
